import { Button, Card, CardContent, Divider, Grid, MenuItem, Chip as MuiChip, TablePagination, TextField } from '@mui/material'
import { GreenText, LabelField } from 'components'
import { DateField } from 'components/fields'
import { ListFilterGroup } from 'components/list'
import { useLayout } from 'context'
import * as controllers from 'controllers'
import { MichiganSOSBundleDto } from 'dtos'
import { useLoadingState } from 'hooks'
import { DEBOUNCE_DELAY } from 'localConstants'
import moment from 'moment'
import { ToDoListNeedsToBeTakenToSecretaryOfStateParameters } from 'parameters'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { formatAddress, formatDateMoment, formatTimeMoment, isPast, useDebounce } from 'utils'

export default function NeedsToBeTakenToSecretaryOfStateToDoListDetails() {
  const navigate = useNavigate()
  const layout = useLayout()

  const [loadingState, setLoadingState] = useLoadingState({
    isGettingVehicles: false
  })

  const [filterField, setFilterField] = useState<string>('')
  const [filterValue, setFilterValue] = useState<string>('')

  const [totalCount, setTotalCount] = useState<number>(0)
  const [michiganSOSBundles, setMichiganSOSBundles] = useState<MichiganSOSBundleDto[]>()
  const [parameters, setParameters] = useState<ToDoListNeedsToBeTakenToSecretaryOfStateParameters>({
    page: 0,
    pageSize: 10,
    orderBy: 'dropOffDate',
    order: 'asc'
  })

  useEffect(() => {
    layout.setTitle('Needs To Be Taken To Secretary of State')
  }, [layout])

  const getNeedsToBeTakenToSecretaryOfStateToDoList = useDebounce((parameters: ToDoListNeedsToBeTakenToSecretaryOfStateParameters) => {
    setLoadingState('isGettingVehicles', true)
    controllers.toDoLists
      .getNeedsToBeTakenToSecretaryOfStateToDoList(parameters)
      .then(response => {
        setTotalCount(response.totalCount ?? 0)
        setMichiganSOSBundles(response.value)
      })
      .finally(() => {
        setLoadingState('isGettingVehicles', false)
      })
  }, DEBOUNCE_DELAY)

  useEffect(() => {
    layout.setIsLayoutLoading(loadingState.isGettingVehicles)
  }, [layout, loadingState.isGettingVehicles])

  useEffect(() => {
    getNeedsToBeTakenToSecretaryOfStateToDoList(parameters)
  }, [getNeedsToBeTakenToSecretaryOfStateToDoList, parameters])

  return (
    <Grid container spacing={1} alignItems='center'>
      <Grid item xs={12}>
        <Card>
          <CardContent>
            <Grid container spacing={1} alignItems='center'>
              <Grid item xs={12} sm={2}>
                <TextField
                  label='Filter Field'
                  onChange={e => {
                    setFilterField(e.target.value)
                    setFilterValue('')
                  }}
                  select
                  value={filterField || ''}
                >
                  <MenuItem value='owner'>Owner</MenuItem>

                  <MenuItem value='dropOffDate'>Drop Off Date</MenuItem>
                </TextField>
              </Grid>

              <Grid item xs={12} sm={2}>
                {filterField === 'dropOffDate' ? (
                  <DateField
                    disabled={!filterField}
                    label='Filter Date'
                    onChange={value => {
                      setFilterValue(value || '')
                    }}
                    value={filterValue}
                  />
                ) : (
                  <TextField
                    disabled={!filterField}
                    label='Filter Value'
                    onChange={e => {
                      setFilterValue(e.target.value)
                    }}
                    value={filterValue || ''}
                  />
                )}
              </Grid>

              <Grid item>
                <Button
                  color='inherit'
                  disabled={!filterField || !filterValue}
                  variant='contained'
                  onClick={() => {
                    setParameters({ ...parameters, [filterField]: filterValue })
                    setFilterField('')
                    setFilterValue('')
                  }}
                >
                  APPLY FILTER
                </Button>
              </Grid>

              <Grid item>
                <Button
                  color='secondary'
                  disabled={!Boolean(parameters.owner || parameters.dropOffDate)}
                  variant='text'
                  onClick={() => {
                    setParameters({
                      ...parameters,
                      owner: undefined,
                      dropOffDate: undefined
                    })
                  }}
                >
                  RESET FILTERS
                </Button>
              </Grid>

              <Grid item xs={12} container spacing={1} alignItems='center'>
                {parameters.owner && (
                  <Grid item xs='auto'>
                    <MuiChip
                      color='secondary'
                      label={`Owner contains "${parameters.owner}"`}
                      onDelete={() => {
                        setParameters({ ...parameters, owner: undefined })
                      }}
                      variant='outlined'
                    />
                  </Grid>
                )}

                {parameters.dropOffDate && (
                  <Grid item xs='auto'>
                    <MuiChip
                      color='secondary'
                      label={`Drop Off Date equals "${formatDateMoment(parameters.dropOffDate)}"`}
                      onDelete={() => {
                        setParameters({ ...parameters, dropOffDate: undefined })
                      }}
                      variant='outlined'
                    />
                  </Grid>
                )}
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>

      {michiganSOSBundles?.map(bundle => (
        <Grid item xs={12} key={bundle.michiganSOSBundleGuid}>
          <Card>
            <CardContent>
              <Grid container spacing={2}>
                {/* <Grid item xs={3}>
                  <LabelField label='Owner' value={bundle?.michiganTitleOwnerName} />
                </Grid>

                <Grid item xs={3}>
                  <LabelField error={isPast(bundle.dropOffDate)} label='Drop Off Date' value={formatDateMoment(bundle.dropOffDate)} />
                </Grid>

                <Grid item xs={3}>
                  <LabelField label='Time' value={formatTimeMoment(bundle.dropOffTime)} />
                </Grid>

                <Grid item xs={3}>
                  <LabelField
                    label='Branch Location'
                    value={bundle.michiganSOSBranchCompanyAddress ? formatAddress(bundle.michiganSOSBranchCompanyAddress) : undefined}
                  />
                </Grid>

                <Grid item xs={3}>
                  <LabelField label='Count' value={bundle.vehicleCount} />
                </Grid>

                <Grid item xs={3}>
                  <LabelField label='Description' value={bundle.description} />
                </Grid> */}

                <Grid item xs={12} sm={3}>
                  <LabelField label='Owner' value={bundle?.michiganTitleOwnerName} />
                </Grid>

                <Grid item xs={12} sm={3}>
                  <LabelField error={isPast(bundle.dropOffDate)} label='Drop Off Date' value={formatDateMoment(bundle.dropOffDate)} />
                </Grid>

                <Grid item xs={12} sm={3}>
                  <LabelField label='Time' value={formatTimeMoment(bundle.dropOffTime)} />
                </Grid>

                <Grid item xs={12} sm={3}>
                  <LabelField
                    label='Branch Location'
                    value={bundle.michiganSOSBranchCompanyAddress ? formatAddress(bundle.michiganSOSBranchCompanyAddress) : undefined}
                  />
                </Grid>

                <Grid item xs={12} sm={3}>
                  <LabelField label='Count' value={bundle.vehicleCount} />
                </Grid>

                <Grid item xs={12} sm={3}>
                  <LabelField label='Description' value={bundle.description} />
                </Grid>

                <Grid item xs={12} container alignItems='center' justifyContent='flex-end'>
                  <Grid item xs={true} sm='auto'>
                    <Button
                      onClick={() => {
                        let to = `/michigan-sos-bundles/${encodeURIComponent(bundle.michiganSOSBundleGuid!)}/needs-to-be-taken-to-secretary-of-state`

                        navigate(to)
                      }}
                      fullWidth
                      variant='contained'
                    >
                      DROP OFF
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      ))}

      <Grid item xs={12}>
        <GreenText>
          {`**Needs To Be Taken To Secretary Of State To List:**

The Michigan Titles - Needs to Be Taken to Secretary of State To-Do List includes Michigan SoS Bundles that meet the following criteria:
   - The bundle has been locked.
   - The bundle does not have a Title Application Delivery Photo uploaded.

This To-Do List is designed for mobile users and is sorted by Drop Off Date (oldest to newest) and then by Owner.

Criteria for Removal:
   - Michigan SoS Bundles are removed from this list when a Title Application Delivery Photo is uploaded. This photo should show the application packet with a cover letter on top, placed inside a mailbox at the Secretary of State office.

**Select To Do List Button:**

Clicking this button will open the “Select To-Do List” dialog.

**Filter Field Drop-Down:**

Clicking the drop-down displays a list of columns available for filtering:
   - Owner,
   - Drop Off Date.

**Filter Value:**

The "Filter Value" field dynamically adjusts based on the selected column in the "Filter Field Drop-Down":
   - Owner: Displays a free-type filter field.
   - Drop Off Date: Displays a Filter Date field.

**Apply Filter Button:**

Clicking this button applies the selected filtering options and updates the displayed data.

**Reset Filters:**

Clicking this button clears all applied filtering options, returning the data view to its default state.

**Owner Label:**

Displays the Owner Name from the Michigan SoS Bundles.

**Drop Off Date:**

Displays the Drop Off Date from the Michigan SoS Bundles. The Drop Off Date value is displayed in bold and red if the date is in the past.

**Time:**

Displays the Time from the Michigan SoS Bundles.

**Branch Location:**

Displays the Branch from the Michigan SoS Bundles.

**Count:**

Displays the Count from the Michigan SoS Bundles.

**Description:**

Displays the Description from the Michigan SoS Bundles.

**Drop Off Button:**

Clicking this button opens the Drop Off Photo Dialog.`}
        </GreenText>
      </Grid>

      <Grid item xs={12}>
        <TablePagination
          component='div'
          count={totalCount}
          onPageChange={(_, page: number) => {
            setParameters({
              ...parameters,
              page
            })
          }}
          onRowsPerPageChange={e => {
            setParameters({
              ...parameters,
              page: 0,
              pageSize: e.target.value as unknown as number
            })
          }}
          page={parameters.page}
          rowsPerPage={parameters.pageSize}
          labelRowsPerPage={
            <Grid container spacing={1}>
              <Grid item>Order By:</Grid>

              <Grid item>
                <TextField
                  InputProps={{ disableUnderline: true, sx: { fontSize: 'inherit', pl: 1 } }}
                  onChange={e => {
                    setParameters({ ...parameters, orderBy: e.target.value })
                  }}
                  select
                  size='small'
                  value={parameters.orderBy}
                  variant='standard'
                >
                  <MenuItem value='dropOffDate'>Drop Off Date</MenuItem>

                  <MenuItem value='owner'>Owner</MenuItem>
                </TextField>
              </Grid>

              <Grid item>
                <TextField
                  InputProps={{ disableUnderline: true, sx: { fontSize: 'inherit', pl: 1 } }}
                  onChange={e => {
                    setParameters({ ...parameters, order: e.target.value as 'asc' | 'desc' })
                  }}
                  select
                  size='small'
                  value={parameters.order}
                  variant='standard'
                >
                  <MenuItem value='asc'>A-Z</MenuItem>

                  <MenuItem value='desc'>Z-A</MenuItem>
                </TextField>
              </Grid>

              <Grid item sx={{ alignSelf: 'stretch' }}>
                <Divider orientation='vertical' />
              </Grid>

              <Grid item>Cards Per Page:</Grid>
            </Grid>
          }
          rowsPerPageOptions={[
            { label: '5', value: 5 },
            { label: '10', value: 10 },
            { label: '25', value: 25 },
            { label: '50', value: 50 },
            { label: '100', value: 100 }
          ]}
          SelectProps={{ fullWidth: false }}
        />
      </Grid>
    </Grid>
  )
}
